// ── 배경색(상태) 다중선택 스와치 필터 (공용) ──────────────────────────────────
//   목록 행 배경색을 상태별로 거르는 색상 스와치 버튼. 색만 표시(텍스트·건수 없음),
//   의미는 hover 툴팁(title). 기본: active 비어 있음 = 전부 표시. 여러 색 중복 선택.
//   filters: [{ key, title, swatch, accent, light? }] — swatch 는 행 배경과 같은 색.
//     light:true 는 흰/밝은 스와치(✓ 를 진한 accent 색으로 그린다).
import React from 'react';

function swatchStyle(active, f) {
  return {
    position: 'relative',
    width: 22,
    height: 22,
    borderRadius: 7,
    padding: 0,
    cursor: 'pointer',
    background: f.swatch,
    border: `1px solid ${active ? f.accent : 'var(--border)'}`,
    boxShadow: active ? `0 0 0 2px ${f.accent}55, 0 1px 3px rgba(0,0,0,0.14)` : 'none',
    opacity: active ? 1 : 0.55,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity .12s, box-shadow .12s',
  };
}

export function ColorSwatchFilter({ filters, active, onToggle }) {
  return (
    <div style={{ display: 'inline-flex', gap: 7, alignItems: 'center' }}>
      {filters.map((f) => {
        const isOn = active.has(f.key);
        // 밝은(흰) 스와치는 채움이 배경과 비슷해 ✓ 를 진한 accent 로, 그 외는 흰 ✓.
        const checkColor = f.light ? f.accent : '#fff';
        return (
          <button
            key={f.key}
            type="button"
            title={`${f.title}${isOn ? ' (필터 켜짐)' : ''}`}
            aria-pressed={isOn}
            onClick={() => onToggle(f.key)}
            style={swatchStyle(isOn, f)}
          >
            {isOn && <span style={{ fontSize: 12, fontWeight: 900, lineHeight: 1, color: checkColor }}>✓</span>}
          </button>
        );
      })}
    </div>
  );
}

export default ColorSwatchFilter;
